import easyfyAxios from '@shared/easyfy.axios';

export interface IReviewListData {
  productid: string;
  page: number;
}

namespace Easyfy.Web.Services.Reviews {
  export const ReviewListGetMore = async (data: IReviewListData, token: string): Promise<any> => {
    return await easyfyAxios.post(`/product?handler=getmorereviews`, data, token);
  };
}

export default Easyfy.Web.Services.Reviews;
